import axios from "axios";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import Button from "@mui/material/Button";
import Grid from '@mui/material/Grid';
import CircularProgress from "@mui/material/CircularProgress";
import Chip from "@mui/material/Chip";

import { styled } from "@mui/material/styles";

import pr_1 from "../photos/product_1.jpg";
import cities from "../json/metroManila.json"; // Import JSON file

import { FaCcMastercard, FaCcVisa, FaCcAmex, FaWallet } from "react-icons/fa";

import "../style/order.css";
export default function Order() {
  const baseURL = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate(); // Initialize useNavigate for redirect

  // Step 1: Create state for the cart items
  const [cartItems, setCartItems] = useState([]);
  const [totalPrice, setTotalPrice] = useState(0);
  const [totalQuan, setTotalQuan] = useState(0);
  const [userID, setUserID] = useState(0);

  const [users, setUsers] = useState({
    id: userID,
    name: "",
    shippingAddress: {
      phone: "",
      emailAddress: "",
      street: "default",
      province: "default",
      city: "default",
      barangay: "default",
    },
    order: [],
    courier: "default",
    payment: "default",
    shippingFee: 0,
    shippingLocation: "default",
    totalPrice: 0,
  });

  const rows = [];

  useEffect(() => {
    const fetchCartItems = async () => {
      try {
        const response = await fetch(`${baseURL}/cart-view`, {
          method: "GET",
          credentials: "include", // Include credentials for authentication
        });

        if (!response.ok) {
          throw new Error("Failed to fetch cart data");
        }

        const data = await response.json();
        const cartItems = data.cartItems; // This will be an array of objects containing prod_id and quantity
        setCartItems(data.cartItems);
        // Now fetch product details based on prod_id
        // console.log(cartItems);

        if (cartItems.length > 0) {
          const productIds = cartItems.map((item) => item.prod_id); // Extracting the prod_id from cart items
          // Fetching products from the product database
          const productResponse = await fetch(
            `${baseURL}/get-products?ids=${productIds.join(",")}`,
            {
              method: "GET",
            }
          );

          if (!productResponse.ok) {
            throw new Error("Failed to fetch product details");
          }

          const products = await productResponse.json();

          // Now map cart items to include product details and quantities
          const enrichedCartItems = cartItems.map((cartItem) => {
            const product = products.find(
              (p) => p.prod_id === cartItem.prod_id
            ); // Assuming products have an 'id' field

            return {
              ...cartItem, // Spread the existing cart item
              prod_id: cartItem.prod_id || null,
              prod_name: product.prod_name || null,
              prod_preorder: product.prod_preorder || "no",
              prod_image: JSON.parse(product.prod_image)[0] || null,
              prod_sale: product.prod_sale || null,
              prod_price: product.prod_price || null,
              prod_quan: cartItem.prod_quan || null, // Include quantity (or whatever the field name is for quantity)
            };
          });

          // // Now map cart items to include product details
          // const enrichedCartItems = cartItems.map((cartItem) => {
          //   const product = products.find((p) => p.id === cartItem.prod_id); // Assuming products have an 'id' field
          //   return {
          //     ...cartItem, // Spread the existing cart item
          //     productDetails: product || null, // Add product details (or null if not found)
          //   };
          // });

          setTotalPrice(
            enrichedCartItems.reduce((acc, item) => {
              const price =
                item?.prod_sale > 0 ? item.prod_sale : item.prod_price;
              const quantity = item.prod_quan || 0;

              // If the product is preorder, count only 50%
              const subtotal =
                item.prod_preorder == "yes"
                  ? price * 0.5 * quantity
                  : price * quantity;

              return acc + subtotal;
            }, 0)
          );

          setUsers((prevState) => ({
            ...prevState,
            totalPrice: enrichedCartItems.reduce(
              (acc, item) =>
                acc +
                ((item?.prod_sale ? item?.prod_sale : item.prod_price) || 0) *
                  (item.prod_quan || 0),
              0
            ),
          }));

          setTotalQuan(
            enrichedCartItems.reduce(
              (acc, item) => acc + (item.prod_quan || 0),
              0
            )
          );

          setCartItems(enrichedCartItems); // Store the enriched cart items with product details

          setUserID(data.user_id);

          setUsers({
            ...users,
            order: enrichedCartItems,
            payment: totalPrice,
          });
        } else {
          setCartItems([]); // No items in the cart
        }
      } catch (error) {
        console.error("Error fetching cart items:", error);
      }
    };

    // Trigger the fetch on component load
    const fetchUser = async () => {
      try {
        const response = await fetch(`${baseURL}/decode-token`, {
          credentials: "include",
        });

        if (!response.ok) throw new Error("Failed to decode token");

        const user = await response.json();
        const userID = user.user_id;

        const profileResponse = await axios.get(`${baseURL}/profile/${userID}`);
        const data = profileResponse.data;

        setUsers((prevState) => ({
          ...prevState,
          id: userID,
          name: data.username,
          shippingAddress: {
            ...prevState.shippingAddress,
            emailAddress: data.user_email,
            phone: data.user_contact,
          },
        }));
      } catch (error) {
        console.error("Error fetching user:", error);
      }
    };

    fetchUser();
    fetchCartItems();
  }, []);

  const handleSendData = async () => {
    try {
      const response = await fetch(`${baseURL}/order`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify(users),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      navigate(`/order-confirmation`, { replace: true });
      window.location.reload();
    } catch (error) {
      console.error("Error sending data:", error);
      alert(
        "There seems to be an error processing your order. Please refresh and try again."
      );
    }
  };

  const getShippingFee = (courier) => {
    const cityLower = users?.shippingAddress?.city?.trim().toLowerCase();
    const metroManilaCities = cities.metro_manila.map((c) => c.toLowerCase());

    if (courier == "Same Day Delivery") {
      if (metroManilaCities.includes(cityLower)) {
        return setUsers((prevUsers) => ({
          ...prevUsers,
          shippingFee: 0,
          shippingLocation: "(Metro Manila)",
        }));
      } else {
        return setUsers((prevUsers) => ({
          ...prevUsers,
          shippingFee: 0,
          shippingLocation: "(Provincial)",
        }));
      }
    }

    if (metroManilaCities.includes(cityLower)) {
      setUsers((prevUsers) => ({
        ...prevUsers,
        shippingFee: 60,
        shippingLocation: "Metro Manila",
      }));
    } else {
      setUsers((prevUsers) => ({
        ...prevUsers,
        shippingFee: 100,
        shippingLocation: "Provincial",
      }));
    }
  };

  const [isFormValid, setIsFormValid] = useState(false);
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  useEffect(() => {
    const allFieldsFilled =
      Object.values(users.shippingAddress).every(
        (field) => field.trim() !== ""
      ) &&
      Object.keys(users)
        .filter(
          (key) =>
            key !== "shippingAddress" &&
            key !== "order" &&
            key !== "id" &&
            key !== "shippingFee"
        )
        .every((key) => users[key].toString().trim() !== "");
    const isEmailValid = emailRegex.test(users.shippingAddress.emailAddress);

    setIsFormValid(allFieldsFilled && isEmailValid);
  }, [users]);

  const [age, setAge] = useState("");

  // // Step 2: Load cart items from localStorage on component mount
  // useEffect(() => {
  //   const updateCartItems = () => {
  //     const storedCart = JSON.parse(localStorage.getItem("cart")) || [];
  //     setCartItems(storedCart); // Store the actual items, not just the length
  //   };

  //   // Trigger cart update initially on component load
  //   updateCartItems();
  // }, []);

  return (
    <div className="Order">
      <div className="order_Field">
        <h3>Personal Information</h3>
        <div className="user">
          <Stack
            direction={{ sm: "column", md: "row", lg: "row" }}
            textAlign={"left"}
            rowGap={1}
            columnGap={1}
            useFlexGap
            flexWrap="wrap"
            className="flex-fields"
          >
            <Stack
              direction="column"
              textAlign={"left"}
              className="flex-fields"
              rowGap={1}
            >
              <InputLabel id="demo-simple-textfield-label">
                Full Name
              </InputLabel>
              <TextField
                required
                id="outlined-error-helper-text"
                label="Required"
                value={users.name}
                onChange={(event) => {
                  setUsers({ ...users, name: event.target.value });
                }}
                sx={{
                  "& .MuiFormHelperText-root": { color: "red" }, // Targets helper text color
                }}
                helperText={
                  users.firstName == "" ? "Please fill up your first name" : ""
                }
              />
            </Stack>
            <Stack
              direction="column"
              textAlign={"left"}
              className="flex-fields"
              rowGap={1}
            ></Stack>
          </Stack>

          <Stack
            direction={{ sm: "column", md: "row", lg: "row" }}
            textAlign={"left"}
            rowGap={1}
            columnGap={1}
            useFlexGap
            flexWrap="wrap"
            className="flex-fields"
          >
            <Stack
              direction="column"
              textAlign={"left"}
              className="flex-fields"
              rowGap={1}
            >
              <InputLabel id="demo-simple-textfield-label">
                Contact Number
              </InputLabel>
              <TextField
                required
                id="outlined-required "
                label="Required"
                value={users.shippingAddress.phone}
                onChange={(event) => {
                  setUsers({
                    ...users,
                    shippingAddress: {
                      ...users.shippingAddress, // Keep the existing properties in shippingAddress
                      phone: event.target.value, // Update only the phone field
                    },
                  });
                }}
                sx={{
                  "& .MuiFormHelperText-root": { color: "red" }, // Targets helper text color
                }}
                helperText={
                  users.shippingAddress["phone"] == ""
                    ? "Please fill up your contact number"
                    : ""
                }
              />
            </Stack>
            <Stack
              direction="column"
              textAlign={"left"}
              className="flex-fields"
              rowGap={1}
            >
              <InputLabel id="demo-simple-textfield-label">
                Email Address
              </InputLabel>
              <TextField
                required
                id="outlined-required"
                label="Required"
                value={users.shippingAddress.emailAddress}
                onChange={(event) => {
                  setUsers({
                    ...users,
                    shippingAddress: {
                      ...users.shippingAddress, // Keep the existing properties in shippingAddress
                      emailAddress: event.target.value, // Update only the phone field
                    },
                  });
                }}
                sx={{
                  "& .MuiFormHelperText-root": { color: "red" }, // Targets helper text color
                }}
                helperText={
                  users.shippingAddress["emailAddress"] == ""
                    ? "Please fill up your email address"
                    : ""
                }
              />
            </Stack>
          </Stack>
        </div>

        <div className="address">
          <h3>Delivery Address</h3>

          <Stack
            direction="column"
            textAlign={"left"}
            className="flex-fields"
            rowGap={1}
          >
            {" "}
            <InputLabel id="demo-simple-select-label">
              Building No./Apartment No./Street
            </InputLabel>
            <TextField
              required
              id="outlined-required"
              label="Address"
              placeholder="Address"
              className="flex-fields"
              onChange={(event) => {
                setUsers({
                  ...users,
                  shippingAddress: {
                    ...users.shippingAddress, // Keep the existing properties in shippingAddress
                    street: event.target.value, // Update only the phone field
                  },
                });
              }}
              sx={{
                "& .MuiFormHelperText-root": { color: "red" }, // Targets helper text color
              }}
              helperText={
                users.shippingAddress["street"] == ""
                  ? "Please fill up your street"
                  : ""
              }
            />
          </Stack>

          <Stack
            direction={"column"}
            textAlign={"left"}
            rowGap={1}
            useFlexGap
            flexWrap="wrap"
            className="flex-fields"
          >
            {" "}
            <InputLabel id="demo-simple-select-label">Barangay</InputLabel>
            <TextField
              required
              id="outlined-required"
              name="city"
              label="Required"
              onChange={(event) => {
                setUsers({
                  ...users,
                  shippingAddress: {
                    ...users.shippingAddress, // Keep the existing properties in shippingAddress
                    barangay: event.target.value, // Update only the phone field
                  },
                });
              }}
              sx={{
                "& .MuiFormHelperText-root": { color: "red" }, // Targets helper text color
              }}
              helperText={
                users.shippingAddress["barangay"] == ""
                  ? "Please fill up your barangay"
                  : ""
              }
            />
          </Stack>

          <Stack
            direction="column"
            textAlign={"left"}
            className="flex-fields"
            rowGap={1}
          >
            {" "}
            <InputLabel id="demo-simple-select-label">City</InputLabel>
            <TextField
              required
              id="outlined-required"
              label="Required"
              onChange={(event) => {
                setUsers({
                  ...users,
                  shippingAddress: {
                    ...users.shippingAddress, // Keep the existing properties in shippingAddress
                    city: event.target.value, // Update only the phone field
                  },
                });
                getShippingFee(event.target.value);
              }}
              sx={{
                "& .MuiFormHelperText-root": { color: "red" }, // Targets helper text color
              }}
              helperText={
                users.shippingAddress["city"] == ""
                  ? "Please fill up your city"
                  : ""
              }
            />
          </Stack>

          <Stack
            direction="column"
            textAlign={"left"}
            className="flex-fields"
            rowGap={1}
          >
            {" "}
            <InputLabel id="demo-simple-select-label">Province</InputLabel>
            <TextField
              required
              id="outlined-required"
              label="Required"
              onChange={(event) => {
                setUsers({
                  ...users,
                  shippingAddress: {
                    ...users.shippingAddress, // Keep the existing properties in shippingAddress
                    province: event.target.value, // Update only the phone field
                  },
                });
              }}
              sx={{
                "& .MuiFormHelperText-root": { color: "red" }, // Targets helper text color
              }}
              helperText={
                users.shippingAddress["province"] == ""
                  ? "Please fill up your province"
                  : ""
              }
            />
          </Stack>

          <Stack
            direction={{ sm: "column", md: "row", lg: "row" }}
            textAlign={"left"}
            rowGap={1}
            columnGap={1}
            useFlexGap
            flexWrap="wrap"
            className="flex-fields"
          >
            {/* <Stack
              direction={"column"}
              textAlign={"left"}
              rowGap={1}
              useFlexGap
              flexWrap="wrap"
              className="flex-fields"
            >
              <InputLabel id="demo-simple-select-label">Zip Code</InputLabel>

              <TextField
                required
                id="outlined-required"
                label="Required"
                placeholder="Zip Code"
                className="flex-fields"
                value={users.shippingAddress.zipCode}
                onChange={(event) => {
                  setUsers({
                    ...users,
                    shippingAddress: {
                      ...users.shippingAddress, // Keep the existing properties in shippingAddress
                      zipCode: event.target.value, // Update only the phone field
                    },
                  });
                }}
              />
            </Stack> */}
          </Stack>
        </div>

        <div className="delivery_Field">
          <h3>Shipping Courier</h3>

          <br />

          <FormControl
            sx={{
              paddingY: 2,
            }}
          >
            {/* <Stack
              direction={{ sm: "column", md: "column", lg: "column" }}
              textAlign={"left"}
              rowGap={1}
              columnGap={1}
              useFlexGap
              flexWrap="wrap"
              className="flex-fields"
            >
              <InputLabel id="demo-simple-select-label">
                Shipping Location
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={users.shippingLocation}
                label="Shipping Location"
                onChange={(event) => {
                  setUsers({ ...users, shippingLocation: event.target.value });
                }}
              >
                <MenuItem value={"Metro Manila"}>Metro Manila</MenuItem>
                <MenuItem value={"Provincial"}>Provincial</MenuItem>
              </Select>
            </Stack> */}

            <br />

            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue="J&T"
              name="radio-buttons-group"
            >
              <Grid container spacing={2}>
                <Grid size={6}>
                  <Stack
                    direction="column"
                    fullWidth
                    sx={{
                      width: "100%",
                    }}
                    spacing={2}
                  >
                    {" "}
                    <Box
                      component="section"
                      sx={{
                        p: 1,
                        border: "1px solid #8888",
                        borderTopLeftRadius: "5px",
                        borderTopRightRadius: "5px",
                        textAlign: "left",
                        height: "50%",
                      }}
                    >
                      <FormControlLabel
                        value="J&T/LBC/Flash Express"
                        control={
                          <Radio
                            size="small"
                            onChange={() => {
                              setUsers({
                                ...users,
                                courier: "J&T/LBC/Flash Express Delivery",
                              });
                            }}
                          />
                        }
                        label="J&T/LBC/Flash Express Delivery"
                      />

                      <hr />

                      <Box sx={{ py: 1, px: 3 }}>
                        <p>We will book the J&T/LBC/Flash Express Delivery.</p>
                        <b>Estimated Days of Delivery </b>
                        <p>
                          <ul>
                            <li>Metro Manila - 2 to 4 Days</li>
                            <li>Provincial - 3 to 5 days</li>
                          </ul>
                        </p>
                      </Box>
                    </Box>
                    <Box
                      component="section"
                      sx={{
                        p: 1,
                        border: "1px solid #8888",
                        textAlign: "left",
                        borderBottomLeftRadius: "5px",
                        borderBottomRightRadius: "5px",
                        height: "50%",
                      }}
                    >
                      <FormControlLabel
                        value="Same_Day"
                        control={
                          <Radio
                            size="small"
                            onChange={() => {
                              setUsers({
                                ...users,
                                courier: "Same Day Delivery",
                              });
                            }}
                          />
                        }
                        label="Same Day Delivery via Grab/Lalamove Delivery"
                      />

                      <hr />

                      <Box sx={{ py: 1, px: 3 }}>
                        <p>
                          Available only within Metro Manila and selected areas
                          within Cavite, Laguna, Rizal, and Bulacan
                        </p>{" "}
                        We will book the Grab/Lalamove delivery. Expect delivery
                        within the day.
                        <br />
                        <p>
                          {" "}
                          Shipping fee varies depending on location. Shipping
                          fee will be calculated after order and payment.
                        </p>
                      </Box>
                    </Box>
                  </Stack>{" "}
                </Grid>
                <Grid size={6}>
                  <Box
                    component="section"
                    sx={{
                      p: 1,
                      border: "1px solid #8888",
                      textAlign: "left",
                      borderBottomLeftRadius: "5px",
                      borderBottomRightRadius: "5px",
                      height: "100%",
                    }}
                  >
                    <b>Shipping Process</b>
                    <hr />

                    <p>
                      For all orders message us your details (Order #, Name,
                      Address, Cellphone Number) here on
                      {"  "}
                      {"  "}
                      <a
                        href="http://www.facebook.com/thevintagecollectiveph"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Facebook/Messenger
                      </a>{" "}
                      or{" "}
                      <a
                        href="http://www.instagram.com/the_vintage_collective"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Instagram
                      </a>{" "}
                      after payment so we can process your order ASAP.
                      <br /> <br /> No cut off. We can book 24/7 even during
                      Holidays.
                    </p>
                  </Box>
                </Grid>
              </Grid>
            </RadioGroup>
          </FormControl>
        </div>

        <div className="payment_Field">
          <h3>Payment Options</h3>

          <FormControl fullWidth sx={{ paddingY: 2 }}>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              name="radio-buttons-group"
            >
              <Grid container direction="column" spacing={2}>
                {" "}
                <Box
                  component="section"
                  sx={{
                    p: 2,
                    border: "1px solid #8888",
                    textAlign: "left",

                    borderTopLeftRadius: "5px",
                    borderTopRightRadius: "5px",
                  }}
                >
                  <h3>E-wallet</h3>
                  <hr />
                  <ul>
                    <li>
                      <FormControlLabel
                        value="Gcash"
                        control={
                          <Radio
                            size="xsmall"
                            className="flex-fields"
                            onChange={() => {
                              setUsers({
                                ...users,
                                payment: "Gcash",
                              });
                            }}
                          />
                        }
                        label="Gcash"
                      />
                    </li>
                  </ul>
                  {/* 
                <Stack direction="row" columnGap={1} justifyContent={"center"}>
                  <FaWallet size={35} />
                </Stack> */}
                </Box>
                <Box
                  component="section"
                  sx={{
                    p: 2,

                    border: "1px solid #8888",
                    textAlign: "left",
                    borderBottomLeftRadius: "5px",
                    borderBottomRightRadius: "5px",
                  }}
                >
                  <h3>Bank Transfer</h3>
                  <hr />

                  <ul>
                    <li>
                      <FormControlLabel
                        value="BDO"
                        control={
                          <Radio
                            size="xsmall"
                            onChange={() => {
                              setUsers({
                                ...users,
                                payment: "BDO",
                              });
                            }}
                          />
                        }
                        label="BDO"
                      />
                    </li>
                    <li>
                      <FormControlLabel
                        value="BPI"
                        control={
                          <Radio
                            size="xsmall"
                            onChange={() => {
                              setUsers({
                                ...users,
                                payment: "BPI",
                              });
                            }}
                          />
                        }
                        label="BPI"
                      />
                    </li>
                    <li>
                      <FormControlLabel
                        value="Seabank"
                        control={
                          <Radio
                            size="xsmall"
                            onChange={() => {
                              setUsers({
                                ...users,
                                payment: "Seabank",
                              });
                            }}
                          />
                        }
                        label="Seabank"
                      />
                    </li>
                  </ul>
                  {/* <Stack direction="row" columnGap={1} justifyContent={"center"}>
                  <FaCcMastercard size={40} />
                  <FaCcVisa size={40} />
                  <FaCcAmex size={40} />
                </Stack> */}
                </Box>
              </Grid>
            </RadioGroup>
          </FormControl>
        </div>

        {/* <Button
          variant="contained"
          onClick={() => {
            console.log(users);
          }}
        >
          Checkout
        </Button> */}

        <button
          className="buttons"
          onClick={handleSendData}
          disabled={!isFormValid}
        >
          Place Order
        </button>
      </div>
      <div className="product_Field">
        <div style={{ position: "fixed" }}>
          <h2>Cart</h2>
          <hr />

          {cartItems.map((items) => (
            <Stack
              direction="row"
              columnGap={2}
              justifyContent={"spaceBetween"}
              alignItems={"center"}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "left",
                  gap: "5px",
                }}
              >
                <Box sx={{ width: "80px" }}>
                  <img src={items.prod_image} alt={items.prod_name} />
                </Box>
              </Box>

              <Box
                sx={{
                  width: "400px",
                  textAlign: "left",
                }}
              >
                {items.prod_name}
                <br />
                {items.prod_preorder === "yes" ? (
                  <Chip
                    label="Pre-Order"
                    size="small"
                    color="warning"
                    style={{ color: "#fff" }}
                  />
                ) : (
                  ""
                )}
              </Box>

              <Box>{items.prod_quan}</Box>
              {/*<Box>
                {items.prod_sale > 0 ? (
                  <span>
                    {/* <strike style={{ color: "red" }}>
                      <b>₱{items.prod_price.toLocaleString("fil-PH")}</b>
                    </strike>{" "} 
                    <b>
                      ₱
                      {(items.prod_sale - items.prod_sale * 0.5).toLocaleString(
                        "fil-PH"
                      )}
                    </b>{" "}
                    <i style={{ color: "red", fontSize: "small" }}>
                      *50% Downpayment
                    </i>
                    <br />
                    <b style={{ color: "#808080" }}>
                      ₱
                      {(items.prod_sale - items.prod_sale * 0.5).toLocaleString(
                        "fil-PH"
                      )}
                    </b>
                  </span>
                ) : (
                  <b>₱{items.prod_price.toLocaleString("fil-PH")}</b>
                )} 

                
              </Box> */}

              <Box style={{ textAlign: "left" }}>
                {items.prod_preorder == "yes" ? (
                  <span>
                    <b>
                      {items.prod_sale > 0 ? (
                        <span>
                          <b>
                            {" "}
                            ₱
                            {(
                              items.prod_sale -
                              items.prod_sale * 0.5
                            ).toLocaleString("fil-PH")}
                          </b>
                          <i style={{ color: "red", fontSize: "small" }}>
                            *50% Downpayment
                          </i>
                          <br />
                          <b style={{ color: "#808080" }}>
                            ₱
                            {(
                              items.prod_sale -
                              items.prod_sale * 0.5
                            ).toLocaleString("fil-PH")}
                          </b>
                        </span>
                      ) : (
                        <span>
                          <b>
                            ₱
                            {(
                              items.prod_price -
                              items.prod_price * 0.5
                            ).toLocaleString("fil-PH")}
                          </b>
                          <i style={{ color: "red", fontSize: "small" }}>
                            *50% Downpayment
                          </i>
                          <br />
                          <b style={{ color: "#808080" }}>
                            ₱
                            {(
                              items.prod_price -
                              items.prod_price * 0.5
                            ).toLocaleString("fil-PH")}
                          </b>
                        </span>
                      )}
                    </b>{" "}
                  </span>
                ) : (
                  <span>
                    {items.prod_sale > 0 ? (
                      <b>₱{items.prod_sale.toLocaleString("fil-PH")}</b>
                    ) : (
                      <b>₱{items.prod_price.toLocaleString("fil-PH")}</b>
                    )}
                  </span>
                )}
              </Box>
            </Stack>
          ))}

          <hr />

          <Stack
            direction="row"
            columnGap={2}
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <Box sx={{ width: "250px", textAlign: "left" }}>
              <h3>Total</h3>
              <i style={{ color: "red", fontSize: "small" }}>
                *Pre-orders require a 50% down payment plus shipping, with the
                remaining balance due before shipment—updates and payment
                notices will be sent via email.
              </i>
            </Box>
            <Box
              sx={{
                width: "235px",
              }}
            ></Box>
            <Box>{totalQuan}</Box>
            <Box>₱{totalPrice}</Box>
          </Stack>
        </div>
      </div>
    </div>
  );
}
